import { UserSearchRequestQuery } from '@lio/api-types';
import { UserQuoteSearchQueryParams } from '@services/user/user.types';

export const userQueryKey = {
  get: ['user'] as const,
  getWithParams: (userId: string) => [...userQueryKey.get, userId] as const,
  search: ['users'] as const,
  searchWithParams: (params: UserSearchRequestQuery) => [...userQueryKey.search, params] as const,
  currentUserRole: ['currentUserRole'] as const,
  currentUser: ['currentUser'] as const,
  searchUserQuotes: ['searchUserQuotes'] as const,
  searchUserQuotesWithParams: (params: UserQuoteSearchQueryParams) =>
    [...userQueryKey.searchUserQuotes, params] as const,
  userBrokerage: ['userBrokerage'] as const,
};
